import useGetFaqTagListPage from '@/hooks/faq/useGetFaqTagListPage';
import useCustomRouter from '@/hooks/useCustomRouter';
import { ROUTES } from '@/types/common';
import { MagazineVo } from '@/types/magazine';

interface FaqTagViewModel {
  faqs: MagazineVo[];
  faqsLoading: boolean;
  onClickMove: (faqPid: string) => void;
}
const useFaqTagViewModel = (tag: string): FaqTagViewModel => {
  const { faqs, faqsLoading } = useGetFaqTagListPage(20, tag);
  const { moveToPage } = useCustomRouter();

  const onClickMove = (faqPid: string) => {
    moveToPage({
      webLink: `${ROUTES.FAQ.DETAIL.path}/${faqPid}`,
      mobileScreenName: ROUTES.FAQ.DETAIL.appScreenName,
      params: {
        id: faqPid,
      },
    });
  };
  return {
    faqs,
    faqsLoading,
    onClickMove,
  };
};

export default useFaqTagViewModel;
